var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1377",
    "data-name": "Grupo 1377",
    transform: "translate(-363 -2851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1371",
    "data-name": "Grupo 1371",
    transform: "translate(7.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_973",
    "data-name": "Caminho 973",
    d: "M0,0H27V27H0Z",
    transform: "translate(355.021 2851)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_974",
    "data-name": "Caminho 974",
    d: "M12.125,16.625h2.25v2.25h-2.25Zm0-9h2.25v6.75h-2.25ZM13.239,2A11.25,11.25,0,1,0,24.5,13.25,11.245,11.245,0,0,0,13.239,2Zm.011,20.25a9,9,0,1,1,9-9A9,9,0,0,1,13.25,22.25Z",
    transform: "translate(355.271 2851.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificacao);
export default __webpack_public_path__ + "static/media/notificacao.ad3e1ebac564fce476dcba8a0be22800.svg";
export { ForwardRef as ReactComponent };